import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleViewer from '../../components/ArticleViewer';
import { PUBLIC_ROUTES } from '../../../../constants/routes';
import '../getting-started/HelpCategoryPage.css';

/**
 * Common Issues & Solutions Article Page
 */
const CommonIssues = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <ArticleViewer 
              title="Common Issues & Solutions"
              showQA={true}
              articleId="common-issues"
            >
              <div className="article-content">
                <p>
                  Here are solutions to the most frequently encountered issues on WeSplit.
                </p>
                
                <h2>Payment Not Processing</h2>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Check your payment method is valid and has sufficient funds</li>
                  <li>Verify your internet connection is stable</li>
                  <li>Try using a different payment method</li>
                  <li>Contact your bank if the issue persists</li>
                </ul>

                <h2>Can't Find a Contact</h2>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Make sure they have a WeSplit account</li>
                  <li>Check if they've enabled privacy settings that prevent being found</li>
                  <li>Try searching by email instead of username</li>
                  <li>Ask them to send you a friend request instead</li>
                </ul>

                <h2>Split Amounts Don't Add Up</h2>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Check for rounding differences (we round to 2 decimal places)</li>
                  <li>Verify all participants are included</li>
                  <li>Review the split method (equal vs custom)</li>
                  <li>Recalculate the split if needed</li>
                </ul>

                <h2>Notifications Not Working</h2>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Check your device notification settings</li>
                  <li>Verify notification preferences in WeSplit settings</li>
                  <li>Make sure the app has notification permissions</li>
                  <li>Try logging out and back in</li>
                </ul>

                <h2>App Crashes or Freezes</h2>
                <p><strong>Solution:</strong></p>
                <ul>
                  <li>Close and restart the app</li>
                  <li>Update to the latest version</li>
                  <li>Clear app cache (Settings → Clear Cache)</li>
                  <li>Reinstall the app if problems persist</li>
                </ul>
              </div>
            </ArticleViewer>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default CommonIssues;
